import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import Button from 'src/components/Button/Button'
import Loader from 'src/components/Loader/Loader'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import { Box, Text, Flex } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import { isEmpty } from 'src/utils/helpers'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from 'src/modules/Inventory/translations'
import styles from 'src/modules/Inventory/Group/Group.module.less'
import DeleteConfirmation from 'src/modals/DeleteConfirmation/index'
import withToast from 'src/components/Toast'
import List from 'src/components/List'
import Disclaimer from 'src/modals/Disclaimer'

class Group extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  state = {
    itemToDelete: null,
  }

  componentDidMount() {
    const { match, getInventoryGroup, history } = this.props
    if (match.params.groupId) {
      getInventoryGroup(match.params.groupId)
    } else {
      // If there is no Group ID in URL redirect
      history.push('/inventory')
    }
  }

  componentDidUpdate(prevProps) {
    const {
      intl,
      getGroupResponse,
      deleteItemResponse,
      toast,
      match,
      getInventoryGroup,
    } = this.props

    // If there is a response and it changed
    if (!isEmpty(getGroupResponse) && getGroupResponse !== prevProps.getGroupResponse) {
      // If there was error getting record
      if (getGroupResponse.success !== true) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            getGroupResponse.message || intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
    if (!isEmpty(deleteItemResponse) && deleteItemResponse !== prevProps.deleteItemResponse) {
      if (deleteItemResponse.success) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appSuccessTitle),
          description: intl.formatMessage(intlMessages.inventoryItemDeleteSuccess),
          status: 'success',
        })

        this.setState({
          itemToDelete: null,
        })
        getInventoryGroup(match.params.groupId)
      } else {
        this.setState({
          itemToDelete: null,
        })
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            deleteItemResponse.message || intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  getItemDescription = item => {
    const { intl } = this.props
    const { total } = item

    return intl.formatMessage(intlMessages.inventoryTotalValue) + ': ' + total
  }

  handleAddItem = () => {
    const { history, group } = this.props

    if (group && group.hasOwnProperty('id') && group.id) {
      history.push('/inventory/' + group.id + '/item/add')
    }
  }

  handleOpenItem = item => {
    const { history, group } = this.props
    if (group && group.hasOwnProperty('id') && group.id && item && item.hasOwnProperty('id')) {
      history.push('/inventory/' + group.id + '/item/edit/' + item.id)
    }
  }

  handleDeleteItem = (e, itemToDelete) => {
    e.stopPropagation()
    // Show delete confirmation dialog
    this.setState({
      itemToDelete: itemToDelete,
    })
  }

  renderItems = items => {
    return items.map(item => {
      return {
        ...item,
        hideArrow: false,
        description: this.getItemDescription(item),
        name: item.name + ' (' + item.quantity + ')',
        onClick: () => this.handleOpenItem(item),
        customRightIcon: () => {
          return (
            <Box>
              <button onClick={e => this.handleDeleteItem(e, item)}>
                <FontAwesomeIconComponent icon={['fal', 'xmark']} size='xs' />
              </button>
            </Box>
          )
        },
        image: item.image,
        leftIcon: ['fal', 'loveseat'],
      }
    })
  }

  renderDeleteConfirmationContent = () => {
    const { intl } = this.props
    return <Text>{intl.formatMessage(intlMessages.inventoryItemDeleteConfirmMessage)}</Text>
  }

  handleCloseDisclaimer = () => {
    this.props.inventorySetItemAddedDisclaimerFalse()
  }

  render() {
    const {
      intl,
      isGetGroupInProgress,
      group,
      items,
      inventoryItemDelete,
      history,
      isDeleteItemInProgress,
      showItemAddedDisclaimer,
    } = this.props

    const { itemToDelete } = this.state

    const countItems = items && items.length > 0 ? items.length : 0
    const countLabel = intl.formatMessage(intlMessages.inventoryItems) + ' (' + countItems + ')'
    const groupName = group.hasOwnProperty('name')
      ? group.name
      : intl.formatMessage(intlMessages.inventoryRoom)
    const groupId = group.hasOwnProperty('id') ? group.id : null

    const classNamesContainer = cx({
      [styles.containerNoItems]: countItems <= 0,
      [styles.container]: true,
    })

    return (
      <Layout>
        <Content>
          <PageTitle
            title={isGetGroupInProgress ? '' : groupName}
            subtitle={countItems > 0 ? `${countLabel}` : `0 Items`}
            showBack={true}
            goBack={() => {
              history.push('/inventory')
            }}
          />

          <Container className={classNamesContainer}>
            {isGetGroupInProgress ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <>
                {countItems > 0 ? (
                  <Text mt={'30px'} variant='secondary' fontSize='16px' fontWeight={500}>
                    {intl.formatMessage(intlMessages.inventoryItems)} ({countItems})
                  </Text>
                ) : (
                  ''
                )}
                {countItems > 0 ? (
                  <div>
                    <Box mt={{ md: '0', lg: '20px' }}>
                      <List items={this.renderItems(items)} isProfile={true} noMargin={true} />
                    </Box>
                  </div>
                ) : (
                  <div className={styles.noRecordsHolder}>
                    <Box
                      mt={'20px'}
                      p={'30px'}
                      opacity={0.5}
                      className={cx({
                        [styles.card]: true,
                        'kiosk--chakra-colors-card-background': true,
                      })}
                      mb={'30px'}
                      align={'center'}
                    >
                      <FontAwesomeIconComponent icon={['fal', 'loveseat']} size='lg' />
                    </Box>
                    <Text fontSize={'14px'} variant='secondary'>
                      {intl.formatMessage(intlMessages.inventoryNoItems)}
                    </Text>
                  </div>
                )}
                <Flex mt={'30px'} justify='center'>
                  <Box maxW={{ lg: '440px', base: '100%' }} w={'100%'}>
                    <Button isFullWidth onClick={this.handleAddItem}>
                      <Box mr={'10px'}>
                        <FontAwesomeIconComponent icon={['fal', 'plus']} size='xs' type='white' />
                      </Box>
                      {intl.formatMessage(intlMessages.inventoryAddNewItem)}
                    </Button>
                  </Box>
                </Flex>
              </>
            )}
          </Container>

          <DeleteConfirmation
            icon={['far', 'trash-can']}
            heading={`${intl.formatMessage(intlMessagesApp.appGlobalDelete)}`}
            subheading={`${itemToDelete && itemToDelete.name}`}
            confirmText={intl.formatMessage(intlMessagesApp.appGlobalDelete)}
            visible={groupId && itemToDelete}
            loading={isDeleteItemInProgress}
            onClose={() => this.setState({ itemToDelete: null })}
            renderContent={this.renderDeleteConfirmationContent()}
            onConfirm={() => inventoryItemDelete(itemToDelete.id)}
          />
          <Disclaimer
            visible={showItemAddedDisclaimer}
            showCustomMessage={true}
            // TODO: See about translation later.
            customMessageFromProp={
              'Please note that not all items listed in your content inventory may be covered. Please review your policy or contact your broker for more information on coverage and limits.'
            }
            loading={false}
            skipAfterHoursCheck={true}
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleCloseDisclaimer}
          />
        </Content>
      </Layout>
    )
  }
}

Group.propTypes = {
  isGetGroupInProgress: PropTypes.bool.isRequired,
  getGroupResponse: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  labels: PropTypes.object.isRequired,
  getInventoryGroup: PropTypes.func.isRequired,
  inventoryItemDelete: PropTypes.func.isRequired,
  deleteItemResponse: PropTypes.object.isRequired,
  intl: PropTypes.object,
  router: PropTypes.object,
}

export default withRouter(injectIntl(withToast(Group)))
